<template>
  <div id="app">
     <IndexPage></IndexPage>
  </div>
</template>

<script>
import IndexPage from './components/IndexPage.vue'

export default {
  name: 'app',
  components: {
    IndexPage
  }
}
</script>

<style>
#app {
  
}

</style>
